import { Flex, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";

const { Title } = Typography;

const BookingDetailsMenuItem = ({
  titleLevel,
  label,
  value,
  icon = undefined,
  editable = false,
  onClick = () => {},
}) => {
  return (
    <Flex justify="space-between" className="width-100" align="center">
      <Title level={titleLevel.sub} style={{ margin: 0, textAlign: "start" }}>
        {label}
      </Title>
      <Title
        level={titleLevel.sub}
        style={{
          margin: 0,
          fontWeight: "500",
          color: "#606060",
          gap: "0.5rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        {icon && icon}
        {value}
        {editable ? (
          <EditOutlined
            onClick={onClick}
            style={{
              marginLeft: "8px",
              cursor: "pointer",
              color: "rgb(250, 87, 5)",
            }}
          />
        ) : (
          <div
            style={{
              width: "1.65rem",
              height: "1.5rem",
            }}
          ></div>
        )}
      </Title>
    </Flex>
  );
};

export default BookingDetailsMenuItem;
